export default __webpack_public_path__ + "static/media/check-icon.7cdab274.svg";